import { render, staticRenderFns } from "./TestDashboard.vue?vue&type=template&id=5fd713ea&scoped=true&"
import script from "./TestDashboard.vue?vue&type=script&lang=js&"
export * from "./TestDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TestDashboard.vue?vue&type=style&index=0&id=5fd713ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd713ea",
  null
  
)

export default component.exports